import React from "react";
import { motion } from "framer-motion";
import { Activity, MapPin, Layers, KeyRound } from "lucide-react";

const CARDS = [
  { Icon: Activity, title: "استریم و بازدید", text: "هرچه اثر شما بیشتر شنیده یا دیده شود، شانس درآمدزایی بیشتری دارد." },
  { Icon: MapPin, title: "کشور مخاطب", text: "ارزش هر استریم در کشورهای مختلف یکسان نیست و ممکن است درآمد متفاوتی ایجاد کند." },
  { Icon: Layers, title: "نوع پلتفرم", text: "درآمد Spotify، Apple Music، YouTube Music، TikTok و سایر سرویس‌ها با فرمول‌های متفاوتی محاسبه می‌شود." },
  { Icon: KeyRound, title: "مالکیت و حقوق اثر", text: "درآمد قابل دریافت به مالکیت اثر، نوع لایسنس و قوانین هر پلتفرم بستگی دارد." },
];

export default function Revenue() {
  return (
    <section id="revenue" className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <h2 className="mt-2 text-3xl md:text-4xl font-bold tracking-tight">
            درآمد موزیک چطور <span className="gradient-text">محاسبه</span> می‌شود؟
          </h2>
          <p className="mt-5 text-slate-300 leading-relaxed">
            درآمد موسیقی عدد ثابت و تضمینی ندارد. درآمد هر اثر به عوامل مختلفی بستگی دارد؛ از جمله تعداد استریم،
            کشور شنونده‌ها، نوع پلتفرم، مدت زمان شنیده شدن، نرخ تبلیغات، نوع محتوا و قوانین پرداخت هر سرویس.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {CARDS.map((c, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="glass glass-hover rounded-3xl p-6 transition-all"
              data-testid={`revenue-card-${i}`}
            >
              <div className="w-10 h-10 rounded-xl bg-white/[0.04] border border-white/10 flex items-center justify-center mb-4">
                <c.Icon className="w-5 h-5 text-cyan-200" strokeWidth={1.6} />
              </div>
              <h3 className="text-base font-bold mb-2">{c.title}</h3>
              <p className="text-sm text-slate-300 leading-relaxed">{c.text}</p>
            </motion.div>
          ))}
        </div>

        <p className="mt-8 text-sm text-slate-400 max-w-3xl">
          ما درآمد قطعی را تضمین نمی‌کنیم، اما مسیر انتشار، مدیریت درآمد و تسویه را برای هنرمندان ایرانی ساده‌تر و شفاف‌تر می‌کنیم.
        </p>
      </div>
    </section>
  );
}
